axios.interceptors.response.use(
    response => {
        // Do something with response data
        return response;
    },
    error => {
        if (error.response.status === 404) {
            window.location = "/404";
        }

        return Promise.reject(error);
    }
);

window.Http = {
    //Helper method for making POST HTTP requests.
    post: function(uri, form, config) {
        config = config !== undefined ? config : {};

        return this.send("post", uri, form, config);
    },

    //Helper method for making PUT HTTP requests.
    put: function(uri, form, config) {
        config = config !== undefined ? config : {};

        return this.send("put", uri, form, config);
    },

    //Helper method for making PATCH HTTP requests.
    patch: function(uri, form, config) {
        config = config !== undefined ? config : {};

        return this.send("patch", uri, form, config);
    },

    //Helper method for making DELETE HTTP requests.
    delete: function(uri, form, config) {
        config = config !== undefined ? config : {};

        return this.send("delete", uri, form, config);
    },

    //Make the request to the server and set the form working
    send: function(method, uri, form, config) {
        return new Promise((resolve, reject) => {
            form.startProcessing();

            axios[method](uri, form.data, config)
                .then(response => {
                    if (response.data.message) {
                        form.setAlert("success", response.data.message);
                    }

                    form.finishProcessing();

                    resolve(response.data);
                })
                .catch(errors => {
                    form.setAlert(
                        "error",
                        errors.response.data.message,
                        errors.response.data.errors
                    );

                    form.finishProcessing();

                    reject(errors.response.data);
                });
        });
    }
};
